import React from 'react';
import PropTypes from 'prop-types';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { disabledButtonTextGray, textColorGray } from 'theme/mainColors';
import { ARRAY_OF_NAME_LABEL_PROP_TYPE } from 'shared/constants/PropTypes';

const textStyle = {
  fontSize: 15,
  color: textColorGray
};

const TTSelectField = ({ items, defaultLabel, value, onValueChange, disabled }) => (
  <SelectField
    hintText={ defaultLabel }
    style={ { width: 280 } }
    maxHeight={ 300 }
    iconStyle={ { fill: disabledButtonTextGray } }
    hintStyle={ { ...textStyle, color: disabledButtonTextGray } }
    labelStyle={ textStyle }
    underlineStyle={ { borderColor: disabledButtonTextGray } }
    value={ value }
    onChange={ onValueChange }
    disabled={ disabled }
  >
    <MenuItem value={ null } primaryText={ defaultLabel } style={ { color: '#bcbcbc' } } />
    {
      items.map((target, index) => (<MenuItem key={ `${target.name}_${index}` } value={ target.name } primaryText={ target.label } />))
    }
  </SelectField>
);

TTSelectField.propTypes = {
  items: ARRAY_OF_NAME_LABEL_PROP_TYPE.isRequired,
  defaultLabel: PropTypes.string.isRequired,
  value: PropTypes.string,
  onValueChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

TTSelectField.defaultProps = {
  disabled: false
};

export default TTSelectField;





// WEBPACK FOOTER //
// ./src/shared/components/translationTable/c/ttSelectField/TTSelectField.js